import React, { useState } from 'react';
import { Stepper } from '@gerdau/hefesto-mais-web';
import useDebounce from '../../../../../../../hooks/useDebounce';

interface IFabricationDebouncedStepperProps {
  value: number;
  onChange(value: number): void;
  onIncreaseClick(): void;
  onDecreaseClick(): void;
  disabled?: boolean;
  placeholder?: string;
  minValue?: number;
}

const FabricationDebouncedStepper: React.FC<
  IFabricationDebouncedStepperProps
> = ({
  value,
  onChange,
  onIncreaseClick,
  onDecreaseClick,
  disabled = false,
  minValue = 1
}) => {
  const [debounceValue, setDebounceValue] = useState(value);

  const debounceOnchangeChange = useDebounce(onChange, 300);

  const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    const validateRegex = new RegExp(/^\d*(\.\d{0,3})?$/); // regex pra aceitar somente números e 3 casas decimais
    setDebounceValue(Number(newValue));

    if (e.type !== 'click') {
      debounceOnchangeChange(Number(newValue));
      return;
    }

    if (validateRegex.test(newValue)) {
      if (Number(newValue) > Number(value)) {
        onIncreaseClick();
        return;
      }
      if (Number(value) > minValue) {
        onDecreaseClick();
        return;
      }
    }
  };

  return (
    <Stepper
      label=""
      name="increaseDrecreaseInput"
      disabled={disabled}
      minLength={minValue}
      value={debounceValue}
      onChange={(e) => onChangeInput(e)}
    />
  );
};

export default FabricationDebouncedStepper;
